const DEFAULT_ENDPOINT = "http://localhost:3000/api/app-feedback";

export type FeedbackPayloadInput = {
  feedbackType: string;
  message: string;
  rating?: number | string | null;
  email?: string | null;
  appArea?: string;
  pagePath?: string;
  appVersion?: string;
  bookId?: string | null;
  chapterId?: string | null;
  activeTab?: string | null;
  errorContext?: string | null;
  /** Set when a captured screenshot will be uploaded after submission. */
  screenshotSizeBytes?: number | null;
};

export function resolveFeedbackEndpoint(candidate: unknown, fallbackBaseUrl?: unknown): string {
  const value = String(candidate || "").trim();
  if (value.startsWith("http://") || value.startsWith("https://")) {
    return value.replace(/\/+$/, "");
  }
  // No explicit endpoint: post to the configured web app base (production/desktop),
  // falling back to the local dev server only when no base is available.
  const base = String(fallbackBaseUrl || "").trim().replace(/\/+$/, "");
  if (base.startsWith("http://") || base.startsWith("https://")) {
    return `${base}/api/app-feedback`;
  }
  return DEFAULT_ENDPOINT;
}

/** Node's `process.platform` when running in the main process; `"web"` in the browser shim. */
function resolvePlatform(): string {
  return typeof process !== "undefined" && process.platform ? process.platform : "web";
}

export function buildFeedbackPayload(input: FeedbackPayloadInput) {
  const screenshotSizeBytes =
    typeof input.screenshotSizeBytes === "number" && input.screenshotSizeBytes > 0
      ? input.screenshotSizeBytes
      : null;
  return {
    feedbackType: input.feedbackType,
    message: input.message,
    rating: input.rating ? Number(input.rating) : null,
    email: input.email || null,
    appArea: input.appArea || "desktop-v2",
    pagePath: input.pagePath || "/desktop-v2",
    metadata: {
      platform: resolvePlatform(),
      appVersion: input.appVersion || "0.1.0-phase1",
      bookId: input.bookId || null,
      chapterId: input.chapterId || null,
      activeTab: input.activeTab || "manuscript",
      errorContext: input.errorContext || null,
    },
    ...(screenshotSizeBytes
      ? { attachments: [{ contentType: "image/png", sizeBytes: screenshotSizeBytes }] }
      : {}),
  };
}
